import React from "react";
import { IconProps } from "./types";

export default function OpenInNewTabIcon({
  width = 24,
  height = 24,
  className = "",
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g clipPath="url(#clip0_58763_2007)">
        <path
          d="M11.0833 11.1868H2.91667V3.02018H7V1.85352H2.91667C2.26917 1.85352 1.75 2.37852 1.75 3.02018V11.1868C1.75 11.8285 2.26917 12.3535 2.91667 12.3535H11.0833C11.725 12.3535 12.25 11.8285 12.25 11.1868V7.10352H11.0833V11.1868ZM8.16667 1.85352V3.02018H10.2608L4.52667 8.75435L5.34917 9.57685L11.0833 3.84268V5.93685H12.25V1.85352H8.16667Z"
          fill="#A8ADB5"
        />
      </g>
      <defs>
        <clipPath id="clip0_58763_2007">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.103516)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
